import { formatDistance } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const distanceBetweenDatesInFull = (value: string): string => {
  const distance = formatDistance(new Date(value), new Date(), {
    addSuffix: true,
    locale: ptBR,
  });
  return distance;
};
